import React from 'react'
import FlipMove from 'react-flip-move'
import PropTypes from 'prop-types'
import { Box, Grid } from '@material-ui/core'
import EditableHTML from '@v4/components/common/EditableHTML'
import ActionButton from '@v4/components/common/Buttons/ActionButton'
import SortHandler from '@v4/components/common/SortHandler'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import clsx from 'clsx'
import Item from './components/Item'
import { useCategory5 } from './Category5.hooks'

const Category5 = props => {
	const [
		{
			classes,
			items,
			direction,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonLink,
			buttonAction,
			buttonTextKey,
			buttonTextConfig,
			buttonTextEditable,
		},
		{ handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange },
	] = useCategory5(props)

	return (
		<Grid container spacing={3} className="category5">
			<SortHandler direction={direction}>
				<Grid item lg={5} md={6} sm={6} xs={12} className="category5-left-container">
					<Box>
						<EditableContainer
							visible={!!text}
							fieldConfig={textConfig}
							onAdd={handleTextChange}
							editable={textEditable}
						>
							<EditableHTML
								key={textKey}
								className={clsx(classes.title, 'category5-text-block-left')}
								html={text}
								onClick={handleTextClick}
								editable={textEditable}
								onChange={handleTextChange}
							/>
						</EditableContainer>
						<EditableContainer
							visible={!!buttonText}
							fieldConfig={buttonTextConfig}
							onAdd={handleButtonTextChange}
							editable={buttonTextEditable}
							label="Button"
							wrapper={({ children }) => (
								<div className={clsx(classes.buttonWrap, 'category5-button-wrapper')}>{children}</div>
							)}
						>
							<ActionButton
								key={buttonTextKey}
								className={classes.button}
								action={buttonAction}
								onClick={handleButtonClick}
								href={buttonLink}
								onChange={handleButtonTextChange}
								editable={buttonTextEditable}
							>
								{buttonText}
							</ActionButton>
						</EditableContainer>
					</Box>
				</Grid>
				<Grid className={classes.empty} item lg={1} />
				<Grid item lg={6} md={6} sm={6} xs={12} className="category5-items-container">
					<Grid container spacing={3} className="category5-items">
						<FlipMove duration={300} typeName={null}>
							{_.map(items, (key, index) => (
								<Grid item key={key} lg={9} md={10} sm={12} xs={12} className="category5-item">
									<Item key={key} group="items" itemKey={key} index={index} />
								</Grid>
							))}
						</FlipMove>
					</Grid>
				</Grid>
			</SortHandler>
		</Grid>
	)
}

Category5.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		buttonLink: PropTypes.instanceOf(PageMetaData),
		buttonAction: PropTypes.instanceOf(PageMetaData),
		mobileButtonWidth: PropTypes.instanceOf(PageMetaData),
		items: PropTypes.instanceOf(PageMetaData),
		textPosition: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default Category5
